import { render, staticRenderFns } from "./AdsNewsletterModal.vue?vue&type=template&id=047966dc"
import script from "./AdsNewsletterModal.vue?vue&type=script&lang=js"
export * from "./AdsNewsletterModal.vue?vue&type=script&lang=js"
import style0 from "./AdsNewsletterModal.vue?vue&type=style&index=0&id=047966dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports